import React from "react";
import ReportPage from "./ReportPage";

export default function PayrollDetailed() {
  return (
    <ReportPage
      title="Payroll Detailed Report"
      subtitle="Detailed gross, deductions and net pay report."
      endpoint="/reports/payroll-detail"
      exportName="payroll-detail"
      summaryCards={[
        { key: "staff_count", label: "Staff Count" },
        { key: "total_gross", label: "Total Gross", money: true },
        { key: "total_deductions", label: "Total Deductions", money: true },
        { key: "total_net", label: "Total Net", money: true },
      ]}
      columns={[
        { key: "pf_no", label: "PF No" },
        { key: "fullname", label: "Name" },
        { key: "gross", label: "Gross" },
        { key: "total_deductions", label: "Deductions" },
        { key: "net", label: "Net" },
        { key: "created_at", label: "Created At" },
      ]}
    />
  );
}
